<template>
  <div>
    <div class="thankyou-page" v-if="invoice">
      <img class="img-responsive ma-auto" src="../../../assets/img/gp-head-hbd@2x.png" width="900px" alt="Celebrate" />
      <div class="container">
        <h1 class="text-center">ขอบคุณ คุณเฌอปรางค์ อารีย์กุล<br />สำหรับการบริจาคและสร้างเพจในโอกาสพิเศษ</h1>
        <h2 class="text-center">เพราะความใจดีของคุณ จึงทำให้น้องๆ มีโอกาสเข้าถึงการศึกษาได้มากขึ้น </h2>
        <div class="block-white">
          <div class="flex-center block-social-share">
            <span>ส่งต่อเพจระดมเงินของคุณให้เพื่อน</span>
            <a href="#"><img class="img-responsive" src="../../../assets/img/btn-fb-share.png" alt="Facebook Share" /></a>
            <a href="#"><img class="img-responsive" src="../../../assets/img/btn-line-share.png" alt="Line Share" /></a>
          </div>
          <div v-if="showUploadSlipForm">
            <div class="block-image-share">
              <img src="../../../assets/img/thankyou-share.png" alt="ThankYou Share" />
            </div>
          </div>
          <div v-if="!showUploadSlipForm">
            <div class="block-image-share">
              <img src="../../../assets/img/thankyou-share.png" alt="ThankYou Share" />
            </div>
          </div>
        </div>
        <div v-if="showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่ คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p></p>หากบริจาคด้วยวิธีการโอนเงิน กรุณายืนยันการโอนเงิน จากแบบฟอร์มด้านล่าง หรือจากลิงก์แบบฟอร์มแจ้งโอนเงินในอีเมลที่ระบบส่งให้</p>
          </div>
        </div>
        <div v-if="!showUploadSlipForm">
          <div class="text-center thankyou-remark">
            <p>อีกสักครู่<br />คุณจะได้รับอีเมลยืนยันการบริจาคจากทางเรา</p>
          </div>
        </div>



      </div> <!--  -->
    </div> <!-- /thankyou-page -->
    <div class="show-uploadslip" v-if="showUploadSlipForm">
      <upload-slip />
    </div>
  </div>
</template>

<script>
  import UploadSlip from '@/components/UploadSlip'

  export default {
    name: 'ThankYouBase',

    components: {
      UploadSlip
    },

    props: {
      invoice: {
        type: Object,
        default: null
      }
    },

    computed: {
      showUploadSlipForm () {
        return this.invoice && this.invoice.payment_method === 'bank_transfer'
      }
    }
  }
</script>

<style scoped lang="scss">
.thankyou-page {
    background: rgb(252,186,62); /* Old browsers */
    background: -moz-linear-gradient(top, rgba(252,186,62,1) 0%, rgba(243,137,0,1) 100%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom, rgba(252,186,62,1) 0%,rgba(243,137,0,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
    color: #242424;
    font-size: 17px;
    position: relative;
    padding-bottom: 2em;
    z-index: 1;
    &:before {
      content: "";
      background: url("../../../assets/img/bg-hex_trans.png") no-repeat top center;
      background-size: 100%;
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: -1;
    }
    // &:after {
    //   content: "";
    //   background: url("../../../assets/img/graphic-hbd-bottom@2x.png") no-repeat bottom center;
    //   background-size: 100%;
    //   width: 100%;
    //   height: 100%;
    //   position: absolute;
    //   left: 0;
    //   bottom: 0;
    // }
    h1 {
      color: #242424;
      font-weight: 400;
      font-size: 1.7em;
      line-height: 1.4em;
    }
    h2 { font-size: 1.2em; }
    h2, h3, h4 {
      color: #242424;
      font-weight: 300;
    }
    .container {
      max-width: 700px;
      margin: 0 auto;
    }
    .block-white {
      padding: 1em;
      margin: 2em 0;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0,0,0,0.23);
      position: relative;
      z-index: 1;
      &:before {
        background: url("../../../assets/img/bg-wave.png") no-repeat left center;
        content: "";
        width: 107%;
        height: 110%;
        position: absolute;
        left: -3%;
        right: -5%;
        background-size: cover;
        top: -5%;
        bottom: -5%;
        z-index: -1;
      }
    }
    .block-social-share {
      font-size: 15px;
      margin: 0 0 10px;
      img { padding-left: 5px; }
      a { z-index: 1; }
    }
    .block-image-share {
      position: relative;
      text-align: center;
    }

  .thankyou-remark {
    font-size: 1em;
    margin: 0 auto 2em;
    max-width: 500px;
  }


  @media all and (max-width: 767px) {
    h1 { font-size: 1.1em; padding: 10px 5px 0;}
    h2 { font-size: 1em; }
    p { padding: 0 10px;}
    .block-white {
      padding: 0.5em;
    }
    .block-image-share {
      margin: 0;
      padding: 0;
      text-align: center;
      background-size: cover;
    }
    .thankyou-remark { font-size: 0.9em; }
  }

  @media all and (max-width: 400px) {
    .block-social-share {
      margin: 5px 0 10px;
      font-size: 0.85em;
      line-height: 1.2em;
    }
  }
}


.show-uploadslip .header-wrapper{
  padding: 0;
  background: #fff;
}

</style>



// WEBPACK FOOTER //
// _birthday.vue?302202f0